/* ----- InputStyles.js ----- */

// Container

//? Container - Display
export const setInputContainerDisplayStyles = () => {
  return { display: "flex", flexDirection: "column" };
};

//? Container - Size
export const setInputContainerSizeStyles = (width) => {
  return { width: width };
};

// Box

//? Box - Border
export const setInputBoxBorderStyles = (borderRadius) => {
  // Border Radius Lookup Object
  const borderRadiusLookup = {
    none: "0px",
    xs: "5px",
    sm: "10px",
    md: "15px",
    lg: "20px",
  };

  const getInputBoxBorderRadius = () => {
    if (borderRadius in borderRadiusLookup) {
      return borderRadiusLookup[borderRadius];
    } else if (new RegExp(/^\d+px$/).test(borderRadius)) {
      return borderRadius;
    }
    // Fallback Value - Default
    else {
      return borderRadiusLookup["xs"];
    }
  };

  return {
    border: "none",
    borderStyle: "solid",
    borderWidth: "1px",
    borderRadius: getInputBoxBorderRadius(),
  };
};

//? Box - Color
export const setInputBoxColorStyles = (isFocused, theme) => {
  const getInputBoxBorderColor = () => {
    return isFocused
      ? theme.palette.primary.main
      : theme.palette.miscellaneous.grey.light;
  };

  return {
    color: theme.palette.miscellaneous.grey.main,
    borderColor: getInputBoxBorderColor(),
  };
};

//? Box - Font
export const setInputBoxFontStyles = (size) => {
  //   Size Lookup Object
  const InputBoxLookup = {
    xs: { fontSize: "10px" },
    sm: { fontSize: "12px" },
    md: { fontSize: "20px" },
    lg: { fontSize: "16px" },
  };

  const sizeKey = InputBoxLookup[size] ? size : "md";

  return InputBoxLookup[sizeKey];
};

//? Box - Size
export const setInputBoxSizeStyles = (size) => {
  //   Size Lookup Object
  const InputSizeLookup = {
    xs: { minWidth: "60px", height: "28px" },
    sm: { minWidth: "80px", height: "32px" },
    md: { minWidth: "100px", height: "48px" },
    lg: { minWidth: "120px", height: "40px" },
  };

  const sizeKey = InputSizeLookup[size] ? size : "md";

  return InputSizeLookup[sizeKey];
};

//? Box - Spacing
export const setInputBoxSpacingStyles = (size) => {
  //   Size Lookup Object
  const InputSpacingLookup = {
    xs: { padding: "0px 8px" },
    sm: { padding: "0px 12px" },
    md: { padding: "0px 16px" },
    lg: { padding: "0px 20px" },
  };

  const sizeKey = InputSpacingLookup[size] ? size : "md";

  return InputSpacingLookup[sizeKey];
};

// Label

//? Label - Color
export const setInputLabelColorStyles = (theme) => {
  return {
    color: theme.palette.primary.main,
  };
};

//? Label - Display
export const setInputLabelDisplayStyles = (label) => {
  if (label === "" || label === undefined) {
    return { display: "none", justifyContent: "center", alignItems: "center" };
  } else {
    return { display: "flex" };
  }
};

//? Label - Font
export const setInputLabelFontStyles = (size) => {
  //   Size Lookup Object
  const InputFontLookup = {
    xs: { fontSize: "10px" },
    sm: { fontSize: "12px" },
    md: { fontSize: "24px" },
    lg: { fontSize: "16px" },
  };

  const sizeKey = InputFontLookup[size] ? size : "md";

  return InputFontLookup[sizeKey];
};

//? Label - Size
export const setInputLabelSizeStyles = (size) => {
  //   Size Lookup Object
  const InputLabelLookup = {
    xs: { height: "20px", width: "100%" },
    sm: { height: "24px", width: "100%" },
    md: { height: "40px", width: "100%" },
    lg: { height: "32px", width: "100%" },
  };

  const sizeKey = InputLabelLookup[size] ? size : "md";

  return InputLabelLookup[sizeKey];
};
